import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Area } from '../../../core/constants/area';
import { AuthLog } from './models/auth-log.model';
import { AuthLogFilter } from './models/auth-log-filter.model';

@Injectable()
export class AuthLogsService {

  constructor(private httpClient: HttpClient) { }

  getAuthLogs(filter: AuthLogFilter) {
    const url = `${environment.dotNetApiUrl}/${Area.auth}/logs`;

    let params = new HttpParams();

    if (filter.startDate) {
      params = params.append('startDate', new Date(filter.startDate).toISOString());
    }

    if (filter.endDate) {
      params = params.append('endDate', new Date(filter.endDate).toISOString());
    }

    if (filter.logTypeId) {
      params = params.append('logTypeId', filter.logTypeId.toString());
    }

    if (filter.userId) {
      params = params.append('userId', filter.userId);
    }

    if (filter.searchText) {
      params = params.append('searchText', filter.searchText);
    }

    if (filter.errorsOnly) {
      params = params.append('errorsOnly', filter.errorsOnly.toString());
    }

    params = params.append('utcOffset', new Date().getTimezoneOffset().toString());

    return this.httpClient.get<Array<AuthLog>>(url, { params: params });
  }
}



// WEBPACK FOOTER //
// ./src/app/developer/logs/auth-logs/auth-logs.service.ts